export default __webpack_public_path__ + "static/media/screenCloseup.4ac9ba71.JPG";